const escrowWalletHR = {
    "view": {
        "title": "Upravljajte svojim Escrow novčanikom",
        "descriptionParagraph1": "Sredstva su zadržana kako bi se osigurala sigurnost i transparentnost tijekom procesa verifikacije. Za označene pjesme, naknada od <strong>15 €</strong> po pjesmi zadržava se u escrowu kako bi se pjesma stavila na bijelu listu za isporuku na Spotify. Ova sredstva će biti vraćena nakon što se potvrdi da su izvođači pjesme legitimni.",
        "descriptionParagraph2": "Koristite tablicu ispod za pregled svih escrow transakcija. Za više detalja, <1><strong>Saznajte više</strong></1>",
        "label": {
            "totalWithheld": "Ukupno zadržano",
            "totalRefunds": "Ukupni povrati"
        },
        "escrowPayments": {
            "title": "Escrow plaćanja",
            "table": {
                "column": {
                    "paymentId": "ID plaćanja",
                    "releaseName": "Izdanje",
                    "amount": "Iznos",
                    "paymentDate": "Datum plaćanja",
                    "paymentAgreement": "Sporazum o plaćanju",
                    "refundProcessed": "Povrat obrađen",
                    "requestRefund": "Zatraži povrat",
                    "details": "Detalji"
                },
                "placeholder": {
                    "search": "Pretraži..."
                },
                "button": {
                    "download": "Preuzmi",
                    "exportCsv": "Izvezi CSV",
                    "view": "Pregledaj",
                    "requestRefund": "Zatraži povrat"
                },
                "label": {
                    "notAvailable": "Nije dostupno"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Zatraži povrat",
                        "body": {
                            "description": "Jeste li sigurni da želite zatražiti povrat za ovo plaćanje?",
                            "note": "Imajte na umu da je ovaj zahtjev podložan pregledu od strane administratora i, ako bude odobren, bit će dodan kao izjava za koju možete izdati račun."
                        },
                        "button": {
                            "confirm": "Potvrdi",
                            "cancel": "Otkaži"
                        },
                        "message": {
                            "success": "Zahtjev za povrat uspješno poslan!",
                            "error": "Nešto je pošlo po zlu, molimo pokušajte ponovno kasnije!"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Raspodjela escrow plaćanja",
            "table": {
                "column": {
                    "paymentId": "ID plaćanja",
                    "trackName": "Pjesma",
                    "amount": "Iznos",
                    "paymentDate": "Datum plaćanja"
                }
            }
        },
        "escrowRefunds": {
            "title": "Escrow povrati",
            "table": {
                "column": {
                    "refundId": "ID povrata",
                    "paymentId": "ID plaćanja",
                    "release": "Izdanje",
                    "amount": "Iznos",
                    "requestDate": "Datum zahtjeva",
                    "status": "Status"
                },
                "label": {
                    "pending": "Na čekanju",
                    "approved": "Odobreno",
                    "rejected": "Odbijeno"
                },
                "tooltip": {
                    "pending": "Vaš zahtjev za povrat trenutno je na čekanju za pregled od strane administratora i uskoro će biti obrađen.",
                    "approved": "Vaš zahtjev za povrat je odobren i izjava je dodana za iznos povrata.",
                    "rejected": "Vaš zahtjev za povrat je odbijen od strane administratora, možete ponovno zatražiti povrat."
                },
                "placeholder": {
                    "search": "Pretraži..."
                },
                "button": {
                    "exportCsv": "Izvezi CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transakcija uspješna :)",
            "description": "Escrow plaćanje je uspješno završeno, relevantno izdanje će uskoro biti stavljeno na bijelu listu!",
            "button": {
                "returnToDashboard": "Povratak na nadzornu ploču"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transakcija otkazana :(",
            "description": "Transakcija je otkazana... Molimo pokušajte ponovno kasnije!",
            "button": {
                "returnToDashboard": "Povratak na nadzornu ploču"
            }
        }
    }
};

export default escrowWalletHR;